var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d6e3ed",
    d: "M3,24.5c-0.8,0-1.5-0.7-1.5-1.5V7c0-0.8,0.7-1.5,1.5-1.5h24c0.8,0,1.5,0.7,1.5,1.5v16 c0,0.8-0.7,1.5-1.5,1.5H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M27,6c0.6,0,1,0.4,1,1v16c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V7c0-0.6,0.4-1,1-1H27 M27,5H3 C1.9,5,1,5.9,1,7v16c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V7C29,5.9,28.1,5,27,5L27,5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M10 9.5A2.5 2.5 0 1 0 10 14.5A2.5 2.5 0 1 0 10 9.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M10,10c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S8.9,10,10,10 M10,9c-1.7,0-3,1.3-3,3s1.3,3,3,3 s3-1.3,3-3S11.7,9,10,9L10,9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M5.5,20.5c0.3-2.2,2.2-4,4.5-4s4.2,1.8,4.5,4H5.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7496c4",
    d: "M10,17c1.9,0,3.4,1.3,3.9,3H6.1C6.6,18.3,8.1,17,10,17 M10,16c-2.8,0-5,2.2-5,5h10 C15,18.2,12.8,16,10,16L10,16z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M17 12H25V13H17zM17 15H25V16H17zM17 18H25V19H17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.90d55f902cf04551d223b2d75b574f69.svg";
export { ForwardRef as ReactComponent };